import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import { httpOk, GET } from 'helpers/api'
import { formatMoney, formatDate, returnSign } from 'helpers/helpers'

function SummaryExpense({ setActiveModal, filterData }) {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [total, setTotal] = useState(0)

	async function searchWithFilter() {
		var filterUrl = "/report/expenses"
		var urlParams = ""

		if (filterData.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterData.start_date
		if (filterData.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterData.end_date

		urlParams += returnSign(urlParams) + 'transaction_type=minus'

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data.data || [])
			setTotal(response.data.total_amount || 0)
		}
	}

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<Modal show={true} animation={false} centered size="xl"
			onHide={() => setActiveModal(false)}>
			<Modal.Header closeButton>
				<Modal.Title>
					{t('expenses')}
					{filterData.start_date && filterData.end_date && filterData.start_date === filterData.end_date &&
						<span className="text-muted fz-14 ms-2">— {formatDate(filterData.start_date)}</span>
					}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="d-flex justify-content-end mb-3">
					<h6 className="mb-0">
						<b>{t('total')}:</b>{' '}
						<span className="text-danger">{formatMoney(total)}</span>
					</h6>
				</div>

				<div className="table-responsive" style={{ maxHeight: '500px', overflowY: 'auto' }}>
					<table className="table table-bordered mb-0">
						<thead>
							<tr>
								<th style={{ minWidth: '33px' }} className="text-center">#</th>
								<th style={{ width: '12%' }}>{t('user')}</th>
								<th style={{ width: '12%' }}>{t('account')}</th>
								<th style={{ width: '15%' }}>{t('type')}</th>
								<th style={{ width: '10%' }}>{t('counterparty')}</th>
								<th style={{ width: '25%' }}>{t('note')}</th>
								<th style={{ width: '13%' }} className="text-center">{t('date')}</th>
								<th style={{ width: '13%' }} className="text-end">{t('amount')}</th>
							</tr>
						</thead>
						<tbody>
							{data.map((item, index) => (
								<tr key={index}>
									<td className="text-center">{index + 1}</td>
									<td className="td-ellipsis">{item.created_by || '—'}</td>
									<td className="td-ellipsis">{item.account_name || '—'}</td>
									<td className="td-ellipsis">{item.payment_purpose_name || '—'}</td>
									<td className="td-ellipsis">{item.counterparty_name || '—'}</td>
									<td className="td-ellipsis">{item.note || '—'}</td>
									<td className="text-center text-nowrap">
										{formatDate(item.created_at, 'dd.MM.yyyy HH:mm')}
									</td>
									<td className="text-end text-nowrap text-danger">
										{formatMoney(item.amount)}
									</td>
								</tr>
							))}
							{data.length === 0 &&
								<tr><td colSpan="8" className="text-center text-muted py-4">{t('list_empty')}</td></tr>
							}
						</tbody>
					</table>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default SummaryExpense
